import { ProductPageContentParams, ProductPageContentType } from "../access/productPageContent/types";
import { File } from "./file";

export class ProductPageContent {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  type: ProductPageContentType;
  productPageSectionId: string;
  title: string;
  description: string;
  position: number;
  parentId: string;
  file?: File;

  constructor(params: ProductPageContentParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.type = params.type;
    this.productPageSectionId = params.productPageSectionId;
    this.parentId = params.productPageSectionId;
    this.title = params.title || '';
    this.description = params.description || '';
    this.position = params.position;
    this.file = params.file ? new File(params.file) : undefined;
  }
}
